export default __webpack_public_path__ + "static/media/675.25d812f1.png";